module.exports = __webpack_public_path__ + "static/media/remove-icon.70f9c9ad.svg";